import { Permission, Role } from "@/api";
import { _permissionsDescriptionMap } from "./rolesAndPermissionsData/permissionsDescriptionMap";
import { _rolesNameMap } from "./rolesAndPermissionsData/rolesNameMap";

export const roles = Object.keys(_rolesNameMap) as Role[];
export const permissions = Object.keys(
  _permissionsDescriptionMap
) as Permission[];

const _roleColorsMap: { [role in Role]: [string, string] } = {
  Admin: ["#007acc", "#FFFFFF"],
  Cliente: ["#4CAF50", "#000000"],
  Tecnico: ["#607D8B", "#FFFFFF"],
  Laboratorio: ["#607D8B", "#FFFFFF"],
  Commerciale: ["#607D8B", "#FFFFFF"],
  AreaManager: ["#607D8B", "#FFFFFF"],
  Service: ["#607D8B", "#FFFFFF"],
};

/**
 * Get the background and foreground colors associated with a role.
 *
 * @param {Role} role - The role for which to retrieve colors.
 * @returns {[string, string]} - A tuple containing the background and foreground colors.
 *                             - Index 0: Background color
 *                             - Index 1: Foreground (text) color
 */
export function getRoleColor(role: Role) {
  return _roleColorsMap[role] || ["#CCCCCC", "#000000"];
}
